import React from 'react'
import 'rc-time-picker/assets/index.css'
import TimePicker from 'rc-time-picker'
import { Form, FormControl, FormGroup, InputGroup, Glyphicon } from 'react-bootstrap'
import moment from 'moment'
import './ck-time-picker.css'

export default class CkTimePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  setOpen({ open }) {
    this.setState({ open })
  }

  onTimeChange(newValue) {
    const curValStr = this.props.value
    const curHour = curValStr.slice(0, curValStr.indexOf(':'))
    const newValStr = newValue !== null ? newValue.format('HH:mm') : ''
    const newHour = newValStr.slice(0, newValStr.indexOf(':'))
    if (newHour === curHour)
      this.setState({ open: false })
    
    this.props.onTimeSaved(newValStr)
  }

  onIconClick(e) {
    this.setState({
      open: true
    })
  }

  onComponentBlur(e) {
    this.setState({ open: false })
  }

  onFocus() {
    this.input.focus()
  }

  renderTimePicker() {
    let {disabled} = this.props
    return (
      <TimePicker
        ref={el => this.input = el}
        disabled={disabled}
        open={this.state.open && !disabled}
        onOpen={this.setOpen.bind(this)}
        onClose={this.setOpen.bind(this)}
        value={
          this.props.value !== ''
            ? moment(this.props.value, 'HH:mm')
            : null
        }
        showSecond={false}
        minuteStep={1} // this.props.minuteStep
        disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 21, 22, 23]}
        hideDisabledOptions
        onChange={this.onTimeChange.bind(this)}
        focusOnOpen={true}
      />
    )
  }

  renderTextInput() {
    return <FormControl type='text' value='' />
  }

  render() {
    return (
      <Form inline>
        <FormGroup
          onClick={this.onIconClick.bind(this)}
        >
          <InputGroup>
            {this.renderTimePicker()}
            <InputGroup.Addon
              style={{display:(this.props.showIcon===true?'':'none')}}
              className='border-none text-md'
              onClick={this.onIconClick.bind(this)}
            >
              <Glyphicon glyph="time" />
            </InputGroup.Addon>
          </InputGroup>
        </FormGroup>
      </Form>
    )
  }
}

CkTimePicker.defaultProps = {
  showIcon: true,
  disabled: false,
  minuteStep: 15
}


// WEBPACK FOOTER //
// ./src/component/element/CkTimePicker.js